const IndustryBodyCard = (props) => {
  return (
    <li className="industry-body-card">
      <img src={props.icon} alt={props.title} />
      <div>
        <h3>{props.title}</h3>
        <p>{props.subtitle}</p>
      </div>
    </li>
  );
};

export default IndustryBodyCard;
